var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconFilmCamera = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.99902 10.371C1.99902 8.12818 1.99902 8.12819 2.19398 7.93323C2.38893 7.73828 2.38893 7.73828 6.25869 7.73828C9.84205 7.73828 10.1073 7.73828 10.2755 7.86601C10.2889 7.87622 10.3018 7.88725 10.3156 7.89915C10.5028 8.06009 10.5028 8.06009 10.522 10.3135C10.5359 11.9325 10.5192 12.6204 10.4626 12.7569C10.4376 12.8171 10.4178 12.8679 10.3869 12.9108C10.2187 13.1441 9.72198 13.1407 6.27403 13.1407C3.52016 13.1407 2.49291 13.1197 2.36398 13.061C2.01216 12.9007 1.99902 12.804 1.99902 10.371ZM10.8786 10.3631C10.8906 9.51497 10.8781 9.61977 12.3283 8.74572C13.1259 8.26498 13.8312 7.87167 13.8957 7.87167C14.0053 7.87167 14.0128 8.03181 14.0128 10.3748C14.0128 12.5108 13.9985 12.8835 13.9152 12.9155C13.8583 12.9373 13.2036 12.5671 12.3484 12.0297C10.8792 11.1064 10.8663 11.2308 10.8786 10.3631Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.40319 5.57941C5.40319 6.52269 4.63852 7.28736 3.69525 7.28736C2.75198 7.28736 1.9873 6.52269 1.9873 5.57941C1.9873 4.63614 2.75198 3.87147 3.69525 3.87147C4.63852 3.87147 5.40319 4.63614 5.40319 5.57941Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5384 5.07338C10.5384 6.29613 9.54721 7.28738 8.32445 7.28738C7.10169 7.28738 6.11045 6.29613 6.11045 5.07338C6.11045 3.85062 7.10169 2.85938 8.32445 2.85938C9.54721 2.85938 10.5384 3.85062 10.5384 5.07338Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconFilmCamera);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon-film-camera.6880fcc31452da5cda1742d444ee0356.svg";